import React from 'react'
import { Typography } from '@mui/material'
import { tonalPalettes } from '@zuto/theme/src/mui/Colors'
import {
  HeadingDomElement,
  TextAlign,
  TypographyColorOptions,
  TypographyVariants
} from './Ui'

type HeadingProps = {
  variant: TypographyVariants
  domElement: HeadingDomElement
  text: string
  align?: TextAlign
  color?: TypographyColorOptions
}

const Heading = ({
  variant,
  domElement,
  text,
  align = 'left',
  color = tonalPalettes.neutral[40] as TypographyColorOptions
}: HeadingProps) => {
  return (
    <Typography variant={variant} component={domElement} align={align} color={color}>
      {text}
    </Typography>
  )
}

export default Heading
